import { render, staticRenderFns } from "./AccountCertifications.vue?vue&type=template&id=4bbb53fb&"
import script from "./AccountCertifications.vue?vue&type=script&lang=js&"
export * from "./AccountCertifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports